// src/api/practitioners.js
// Wrappers for the practitioner portal. Read-only client access + connect codes.
// Connect codes use the shared /connect-codes route (issuer resolved to the
// practitioner automatically by the backend).

import client from "./client";
import { tokenStore } from "./client";
import { API_URL } from "../config";

const unwrap = (res) => res.data.data;

const apiError = (err) => {
  const body = err.response?.data;
  const e = new Error(body?.error || "Something went wrong. Try again.");
  e.code = body?.code || "NETWORK";
  e.status = err.response?.status || 0;
  return e;
};

const run = async (promise) => {
  try {
    return unwrap(await promise);
  } catch (err) {
    throw apiError(err);
  }
};

// ---- clients ---------------------------------------------------------------
export const listClients = (params = {}) =>
  run(client.get("/practitioners/clients", { params }));

export const getClientSummary = (userId, params = {}) =>
  run(client.get(`/practitioners/clients/${userId}/summary`, { params }));

export const getClientExpenses = (userId, params = {}) =>
  run(client.get(`/practitioners/clients/${userId}/expenses`, { params }));

export const getClientReceipts = (userId) =>
  run(client.get(`/practitioners/clients/${userId}/receipts`));

export const getClientReceipt = (userId, receiptId) =>
  run(client.get(`/practitioners/clients/${userId}/receipts/${receiptId}`));

// ask a client to finish their year - push notification, once per day
export const nudgeClient = (userId, body = {}) =>
  run(client.post(`/practitioners/clients/${userId}/nudge`, body));

// authenticated image URL (fetched as blob with bearer token, same as user receipts)
export const clientReceiptImageUrl = (userId, receiptId) =>
  `${client.defaults.baseURL}/practitioners/clients/${userId}/receipts/${receiptId}/image`;

// ---- connect codes (shared route, issuer resolved to practitioner) ----------
export const listCodes = () => run(client.get("/connect-codes"));
export const issueCode = (body = {}) => run(client.post("/connect-codes", body));
export const revokeCode = (id) => run(client.post(`/connect-codes/${id}/revoke`));

// ---- dashboard (release status across clients) -----------------------------
export const getDashboard = (params = {}) =>
  run(client.get("/practitioners/dashboard", { params }));

// ---- tax pack download (binary, bypasses axios interceptor) -----------------
export const downloadClientTaxPack = async (userId, taxYear) => {
  const res = await fetch(`${API_URL}/practitioners/clients/${userId}/tax-pack?tax_year=${taxYear}`, {
    headers: { Authorization: `Bearer ${tokenStore.access}` },
  });
  if (!res.ok) {
    let message = "Could not download the tax pack.";
    try { const j = await res.json(); message = j.error || message; } catch (e) { /* non-JSON */ }
    throw new Error(message);
  }
  return res.blob();
};